function Communications() {
  return (
    <div>
      <h1>Communications</h1>
      <p>Welcome to Club OS Communications</p>
    </div>
  );
}

export default Communications;